<h1 class="save-line-head" i18n='@@title-PaymentMethods'>Metodi di pagamento</h1>

@if (loaded) {
  <div>
    <div class="flex-row">
      @if (typeList.includes('APPLEPAY')) {
        <div> <!-- Temporary FALSE -->
          <a routerLink="applepay">
            <mat-card class="card">
              <mat-icon svgIcon='credit-card' style="height: 30px; width: 30px; margin-right: 10px;"></mat-icon>
              <ng-container>Apple Pay</ng-container>
              <mat-icon class="material-icons" style="text-align: end;">keyboard_arrow_right</mat-icon>
            </mat-card>
          </a>
        </div>
      }
      @if (typeList.includes('PAYPAL')) {
        <div>
          <a routerLink="paypal">
            <mat-card class="card">
              <mat-icon svgIcon='credit-card' style="height: 30px; width: 30px; margin-right: 10px;"></mat-icon>
              <ng-container>PayPal</ng-container>
              <mat-icon class="material-icons" style="text-align: end;">keyboard_arrow_right</mat-icon>
            </mat-card>
          </a>
        </div>
      }
      @if (typeList.includes('SPAY')) {
        <div>
          <a routerLink="satispay">
            <mat-card class="card">
              <mat-icon svgIcon='credit-card' style="height: 30px; width: 30px; margin-right: 10px;"></mat-icon>
              <ng-container>Satispay</ng-container>
              <mat-icon class="material-icons" style="text-align: end;">keyboard_arrow_right</mat-icon>
            </mat-card>
          </a>
        </div>
      }
    </div>
  </div>
}

@if (loaded && typeList.length === 0) {
  <div>
    <h3 i18n='@@nogateWay'>Nessun metodo di pagamento alternativo disponibile.</h3>
  </div>
}
